import React, {useState, useEffect} from "react"
import {Modal} from "../Modals/Modal"
import Admonition from "../Admonitions/Admonition"
import Button from "../Button/Button"

const snippet = `<script
    async
    src="https://ui.s.unit.sh/release/latest/components-extended.js"
  ></script>
  <unit-elements-white-label-app jwt-token="{{JwtToken}}"></unit-elements-white-label-app>`

interface CopyCodeModalProps {
	close: () => void
}

export function CopyCodeModal({close}: CopyCodeModalProps) {
	const [copied, setCopied] = useState(false)

	useEffect(() => {
		let timer: number
		if (copied) {
			timer = window.setTimeout(() => setCopied(false), 3000)
		}
		return () => {
			if (timer) clearTimeout(timer)
		}
	}, [copied])

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(snippet)
			setCopied(true)
		} catch (err) {
			console.error("Copy failed:", err)
		}
	}

	return (
		<Modal close={close} enableClickAway={false} blockBodyScroll classname="copy-code-modal-container">
			<div className="copy-code-modal">
				<h2 className="copy-modal-title">Copy this code snippet into your product</h2>

				<pre className="copy-modal-code">
					<code>{snippet}</code>
				</pre>

				<Admonition
					type="is-warning"
					message="Don’t forget to replace the JWT token with your actual JWT"
					isFullWidth
				/>
				<div className="button-container">
					<Button
						prefixIcon={copied ? undefined : "paginate-filter-document-copy"}
						rounded
						className="copy-modal-button"
						onClick={handleCopy}
						type="button"
					>
						{copied ? "Copied!" : "Copy"}
					</Button>
				</div>
			</div>
		</Modal>
	)
}
